import {uniqueId} from 'lodash'

const routeToClientCard = {
  name: 'ContactCard',
  params: {
    id: 'id'
  },
  paramName: 'id',
  paramValue: 'client.id',
  props: true
}

const columns = [
  {
    title: 'PAID ON',
    type: 'date',
    prop: 'paymentDate',
    typeTable: 'kpiInfo',
    placeholder: 'N/A',
    info: {
      display: 'project.includeOfKpiComment',
      text: 'project.includeOfKpiComment'
    },
    padding: true,
    width: 'minmax(82px, 147px)'
  },
  {
    title: 'CLIENT\'S NAME',
    prop: 'client.name',
    route: routeToClientCard,
    hover: true,
    typeTable: 'kpiInfo',
    width: 'minmax(88px, 172px)'
  },
  {
    title: 'SERVICE NAME',
    prop: 'service.name',
    nameRoute: 'ProjectCard',
    nameProject: {
      display: 'project.name',
      text: 'project.name'
    },
    checkRoute: 'serviceProjectManagerInstanceIdIsDelete',
    billet: {
      text: ['Dues paid', 'Split %'],
      display: ['isDouble', 'project.kpiHelpUsers.length']
    },
    enum: {
      prop: 'createType',
      getter: (val) => {
        switch (val) {
        case 2:
          return 'Proj'
        case 3:
          return 'Inv'
        default:
          return ''
        }
      }
    },
    width: 'minmax(182px, 266px)'
  },
  {
    title: 'PROFORMA NO.',
    prop: 'invoice.number',
    hover: true,
    actionType: 'openProforma',
    typeTable: 'kpiInfo',
    width: 'minmax(109px, 193px)'
  },
  {
    title: 'AMOUNT',
    prop: 'amount',
    type: 'number',
    padding: true,
    width: 'minmax(62px, 146px)'
  },
  {
    title: 'FACT',
    prop: 'factValue',
    type: 'number',
    info: {
      display: 'project.managerComment',
      text: 'project.managerComment'
    },
    typeEditable: 'number',
    error: 'factError',
    notMore: 'assignedValue',
    width: 'minmax(60px, 144px)'
  },
  {
    title: 'COMPLETION DATE',
    prop: 'approvedDate',
    type: 'date',
    padding: true,
    pointer: true,
    width: 'minmax(108px, 149px)'
  },
  {
    title: 'TO BE EARNED',
    prop: 'approvedValue',
    typeTable: 'kpiInfo',
    type: 'number',
    height: true,
    background: true,
    customClass: (value) => value < 0 ? 'bb-block bb-block__negative-number' : 'bb-block bb-block__center',
    hoverClass: 'bb-block_hover',
    width: 'minmax(84px, 106px)'
  },
  {
    title: 'TO BE EARNED, %',
    prop: 'assignedPercent',
    postfix: '%',
    background: true,
    height: true,
    customClass: () => {
      return 'bb-block'
    },
    hoverClass: 'bb-block_hover',
    width: 'minmax(110px, auto)',
    padding: true
  }
]

const prefix = 'kpi_potential_column_'
const totalPotentialTable = columns.map(col => {
  col.mark = 'potential'
  col.id = uniqueId(prefix)
  return col
})

export default totalPotentialTable



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/totalPotentialTable.js